
/**
 * 認証不要ルート用
 * @see https://github.com/sewii/Yokumiru/issues/581
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

require('./foundation-pre-auth')

// instance property
window.Vue.prototype.$locale = {
    type: 'consul',
    appName: 'YOKUMIRU',
    appNameJa: 'ヨクミル',
    patient: '会員',
    consultation: '医療相談',
    consultation_host: '相談',
    consultation_guest: '相談',
    question: '相談内容',
}

// vue-router
const routes = [];
const router = new VueRouter({
    mode: 'history',
    routes,
})

// create instance
const app = new Vue({
    el: '#app',
    store,
    router,
})
